// @ts-nocheck
/* eslint-disable */
import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';

const EspValidate = new ReduxAsyncAction('ESP_VALIDATE', ['set', 'reset']);
EspValidate.registerRequest(function (url, method) {
  return dash_api.post(`/v1/3p-onboarding/validate`, { url, method }).then(({ data }) => data);
});

export const espValidate = EspValidate.request;
export const ESP_VALIDATE = EspValidate.constants;

export function espSet(new_state) {
  return function (dispatch) {
    dispatch({
      type: ESP_VALIDATE.set,
      new_state,
    });
  };
}

// will replace state with merged inital state and new_state argument if specified
export function espReset(new_state) {
  return function (dispatch) {
    dispatch({
      type: ESP_VALIDATE.reset,
      new_state,
    });
  };
}

export const URL_TO_METATAG_MATCHING = 'url_to_metatag_matching';
export const AUTO_FETCH = 'auto_fetch';
export const BRANCH_LINK = 'branch_link';
